import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ApiError } from "../Table/ApiError";

type Props = {
  action?: () => Promise<void> | void;
  kind: "table" | "chart" | "page";
};

export const ErrorContent = ({ action, kind }: Props) => {
  const { t } = useTranslation();

  const translations = useMemo(() => {
    const base = {
      page: {
        errorTitle: t("clientsPage_page_error_title"),
        errorText: t("clientsPage_page_error_text"),
        errorActionText: t("clientsPage_data_error_action_text"),
      },
      table: {
        errorTitle: t("clientsPage_table_error_title"),
        errorText: t("clientsPage_table_error_text"),
        errorActionText: t("clientsPage_data_error_action_text"),
      },
      chart: {
        errorTitle: t("clientsPage_chart_error_title"),
        errorText: t("clientsPage_chart_error_text"),
        errorActionText: t("clientsPage_data_error_action_text"),
      },
    } as const;
    return base;
  }, [t]);

  const translationProps = translations[kind];
  return <ApiError kind={kind} {...translationProps} action={action} />;
};
